import { render, staticRenderFns } from "./oneDetail.vue?vue&type=template&id=468b2f42&scoped=true"
import script from "./oneDetail.vue?vue&type=script&lang=js"
export * from "./oneDetail.vue?vue&type=script&lang=js"
import style0 from "./oneDetail.vue?vue&type=style&index=0&id=468b2f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b2f42",
  null
  
)

export default component.exports